const fullMarketplaceCountries = new Set(
  "AU AT BE BG CA HR CY CZ DK EE FI FR DE GI GR HK HU IE IT JP LV LI LT LU MT MX NL NZ NO PL PT RO SG SK SI ES SE CH TH AE GB US"
    .split(" ")
);

const directoryOnlyCountries = new Set("CU IR KP RU SY".split(" "));

export const centreMarketCapability = (countryCode = "AU") => {
  const country = String(countryCode || "AU").trim().toUpperCase();
  if (directoryOnlyCountries.has(country)) {
    return {
      countryCode: country,
      mode: "directory_only",
      onlinePayments: false,
      payouts: false,
      offlineBookings: false,
      label: "Free directory listing",
      description: "Public listing and enquiries are available. Court commerce is not available in this market."
    };
  }
  if (fullMarketplaceCountries.has(country)) {
    return {
      countryCode: country,
      mode: "full_marketplace",
      onlinePayments: true,
      payouts: true,
      offlineBookings: true,
      label: "Online bookings and payouts",
      description: "Eligible centres can use Badminta Checkout and receive payouts after Stripe verification."
    };
  }
  return {
    countryCode: country,
    mode: "offline_booking",
    onlinePayments: false,
    payouts: false,
    offlineBookings: true,
    label: "Bookings with centre settlement",
    description: "Centres can manage reservations and collect payment directly until Badminta Pay is available locally."
  };
};

export const centreMarketCapabilityCounts = Object.freeze({
  fullMarketplaceCountries: fullMarketplaceCountries.size,
  directoryOnlyCountries: directoryOnlyCountries.size
});
